var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"containerEmote"},[_c('w-tool-tip',{attrs:{"label":_vm.tootlTipLabel,"position":'bottom',"delay":1000}},[_c('img',{staticClass:"imageEmote",attrs:{"alt":"emote","src":_vm.url,"data-test":"commentEmojiButton"},on:{"click":_vm.sendComment}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }